import type { ColorKeys } from '../../styles/colors'
import { getColor } from '../../styles/colors'

function Facebook( { color = 'white' as ColorKeys, title = 'Facebook' } ) {
  const theColor = getColor( color )

  return (
    <svg 
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ title }</title>
      <path 
        d="M2.06031 16V8.70996H0.0703125V6.05997H2.06031V3.73997C2.06031 2.70997 2.39031 1.83997 3.06031 1.13997C3.73031 0.439965 4.72031 0.0899658 6.03031 0.0899658C6.36031 0.0899658 6.69032 0.0999658 7.02032 0.129966C7.35032 0.159966 7.60031 0.179965 7.76031 0.199965L8.02032 0.239965L7.91032 2.73997H6.20032C5.73032 2.73997 5.42032 2.84997 5.27032 3.06997C5.12032 3.28997 5.04031 3.61997 5.04031 4.05997V6.04996H8.02032L7.82031 8.69996H5.04031V15.99H2.06031V16Z"
        fill={ theColor }
      />
    </svg>
  )
}

export default Facebook
